import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../types/AppState';

/**
 * Custom hook to get an ECC's preconfigured messages for initiating
 * text-from-911 chats. Initial release is hardcoded messages
 *
 * TODO: We should remove this hook as preconfigured messages are now handled
 * elsewhere. It is now only used by useVideoSessionInitialization, which
 * consumes the first message on the start-chat flow (defaultMessage + message
 * with video link).
 */
const usePreconfiguredMessages = () => {
  const eccDisplayName = useSelector(
    (state: AppState) => state.psaps.currentPSAP?.name,
  );

  const defaultMessage = useMemo(
    () =>
      `Hello, this is ${eccDisplayName} reaching out in response to an emergency`,
    [eccDisplayName],
  );
  const secondMessage = useMemo(
    () =>
      `Hello, this is ${eccDisplayName} reaching out to inquire whether you need emergency assistance, you may respond here or call 911.`,
    [eccDisplayName],
  );

  return [defaultMessage, secondMessage];
};

export default usePreconfiguredMessages;
